/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TimeZoneModel } from '../../models/time-zone-model';

export interface MasterDataTimeZonesGet$Params {
}

export function masterDataTimeZonesGet(http: HttpClient, rootUrl: string, params?: MasterDataTimeZonesGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<TimeZoneModel>>> {
  const rb = new RequestBuilder(rootUrl, masterDataTimeZonesGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<Array<TimeZoneModel>>;
    })
  );
}

masterDataTimeZonesGet.PATH = '/MasterData/TimeZones';
